import dayjs from "dayjs";
import React, { use, useEffect, useState } from "react";
import { request } from "../../../utils/request";
import { getCurrentMonthName } from "../../../utils/helpers";
import AppChart from "../AppChart";
import AppCardVendedor from "../AppCardVendedor";
import GraficoBarrasVendedor from "../GraficoBarrasVendedor";
import AppLineVendedor from "../AppLineVendedor";

const VendedoresDashboard = () => {
    const [diasDelMes, setDiasDelMes] = useState([]);
    const [chartDashboard, setChartDashboard] = useState();
    const [lastThreeMonthsChartDashboard, setLastThreeMonthsChartDashboard] = useState();
    const [graficoBarras, setGraficoBarras] = useState();
    const [desde, setDesde] = useState(dayjs().format('YYYY-MM-DD'));
    const [hasta, setHasta] = useState(dayjs().format('YYYY-MM-DD'));
    
    const mes = parseInt(dayjs().format("M"));
    const anio = parseInt(dayjs().format("YYYY"));

    const getDashboard = async (url = "dashboard/gi?vendedor=1") => {
		const dashboard = await request(url);

		if (dashboard.success) {
            setLastThreeMonthsChartDashboard(dashboard.data.lastThreeMonthsChartDashboard);
            setChartDashboard(dashboard.data.chartDashboard);
            setGraficoBarras(dashboard.data.graficoBarras);
		}
	};

    const filtroQuery = () => {
		const query = [`mes=${mes}`, `anio=${anio}`, `vendedor=1`];
		getDashboard("dashboard/gi?" + query.join("&"));
	};

    useEffect(() => {
        getDashboard();
    }, []);

    useEffect(() => {
        filtroQuery();
    }, [mes, anio]);

    const anioActual = parseInt(dayjs().format('YYYY'));

    let months = [];
	let years = [];
    for (let month = 0; month < 12; month++) {
        months.push({
            numero: month + 1,
            nombre: getCurrentMonthName(month),
        });
    }
    for (let year = 2012; year <= anioActual; year++) {
        years.push(year);
    }

    const dDay = dayjs(desde).format('DD');
    const dMes = getCurrentMonthName(dayjs(desde).format('M') - 1);
    const dAnio = dayjs(desde).format('YYYY');
    let titulo = `Estadísticas ${dDay} de ${dMes} ${dAnio}`
    if (desde !== hasta) {
        const hDay = dayjs(hasta).format('DD');
        const hMes = getCurrentMonthName(dayjs(hasta).format('M') - 1);
        const hAnio = dayjs(hasta).format('YYYY');

        if (dAnio !== hAnio) {
            titulo = `Estadísticas desde el ${dDay} de ${dMes} ${dAnio} hasta el ${hDay} de ${hMes} ${hAnio}`
        } else if (dMes !== hMes) {
            titulo = `Estadísticas desde el ${dDay} de ${dMes} hasta el ${hDay} de ${hMes} ${hAnio}`
        } else {
            titulo = `Estadísticas desde el ${dDay} hasta el ${hDay} de ${hMes} ${hAnio}`
        }
    }

    return <div className="dashboard">
        <section className="dashboard-header">
            <h1>{titulo}</h1>
            <div className="dashboard-dates row">
                <div className="col-12 col-md-6">
                    <label
                        htmlFor="desde"
                        style={{ fontSize: "12px", textTransform: "uppercase" }}
                    >
                        Desde
                    </label>
                    <input
                        type="date"
                        name="desde"
                        id="desde"
                        className="form-control"
                        value={desde}
                        onChange={(e) =>
                            setDesde(e.target.value)
                        }
                    />
                </div>
                    <div className="col-12 col-md-6">
                        <label
                            htmlFor="hasta"
                            style={{ fontSize: "12px", textTransform: "uppercase" }}
                        >
                            Hasta
                        </label>
                    <input
                        type="date"
                        name="hasta"
                        id="hasta"
                        defaultValue={hasta}
                        className="form-control"
                        onChange={(e) =>
                            setHasta(e.target.value)
                        }
                    />
                </div>
            </div>
        </section>

        <div className="row">
            <div className="col-12 col-md-5 m-0 px-2">
                <AppCardVendedor
                    desde={desde}
                    hasta={hasta}
                />


                    <GraficoBarrasVendedor
						data={{
							gastosInternos: {
								label: "Despachos internos",
								value: graficoBarras?.gastosInternos,
							},
						}}
					/>

            </div>

            <div className="col-12 col-md-7 m-0 px-2">
                <div className="row">
                    <div className="col-12">
                        <AppChart
                            diasDelMes={diasDelMes}
                            chartDashboardData={chartDashboard}
                        />
                    </div>

                    <div className="col-12 dashboard-row">
                        <AppLineVendedor
                            diasDelMes={diasDelMes}
                            LastThreeMonthsChartDashboard={lastThreeMonthsChartDashboard}
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>;
};

export default VendedoresDashboard;
